import {useEffect, useRef} from 'react';

// deck.gl is loaded only when someone chooses Density; normal browsing and
// the default cluster view do not download or initialise the graphics library.
export default function AssetDensityLayer({map, points, onStatus}) {
    const overlay = useRef();
    const latestPoints = useRef(points);

    useEffect(() => {
        latestPoints.current = points;
        overlay.current?.setPoints(points);
    }, [points]);

    useEffect(() => {
        let cancelled = false;
        onStatus('loading');
        const timeout = setTimeout(() => {
            if (!cancelled) onStatus('unavailable');
        }, 8000);
        const status = value => {
            if (cancelled) return;
            if (value !== 'loading') clearTimeout(timeout);
            onStatus(value);
        };
        import('./assetDensityOverlay').then(({createAssetDensityOverlay}) => {
            if (cancelled) return;
            overlay.current = createAssetDensityOverlay(map, status);
            overlay.current.setPoints(latestPoints.current);
        }).catch(() => status('unavailable'));
        return () => {
            cancelled = true;
            clearTimeout(timeout);
            overlay.current?.finalize();
            overlay.current = null;
        };
    }, [map, onStatus]);

    return null;
}
